module.exports = require("./nn-NO");